import { createBrowserHistory } from 'history';
const history = createBrowserHistory({ basename: '/login' });
export default history;

